import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { Brand } from '../../../../components/actionable-filter-pill/connected/orders/brand';
import { messages } from './messages';

export const BRAND_FILTER_ID = 'company-name';

export const SellerBrand = {
  id: BRAND_FILTER_ID,
  displayName: <FormattedMessage {...messages.companyName} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'SellerBrandId',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },

  actionableFilterPill: Brand,
};
